import { createApp } from 'vue';
import App from './App.vue';
import common from './comm/common';
import vuetify from './plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';
import router from './router';
import store from './store';
import axios from './plugins/axios';

import '../public/css/main.css';
import '../public/css/main-m.css';
import '../public/css/tabs.css';
import '../public/css/jspreadsheet.css';

import '@fontsource/noto-sans-kr/400.css';
import '@fontsource/noto-sans-kr/500.css';
import '@fontsource/noto-sans-kr/700.css';

loadFonts()

const app = createApp(App);

//저장소 전역 설정
app.use(store);

//router 전역 설정
app.use(router);

//vuetify 전역 설정
app.use(vuetify);

app.use(common);

app.mount('#app');

// 전역 설정
app.config.globalProperties.$store = store;
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$router = router; 